import React from "react";
import { useLocation } from 'react-router-dom';
import { AuthConsumer } from "./AuthContext";

const Callback = () => {
  const location = useLocation();

  return (
    <AuthConsumer>
      {({authenticate}) => {
        if (/access_token|id_token|error/.test(location.hash)) {
          authenticate();
        }
      }}
    </AuthConsumer>
  )
};

export default Callback;
